import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, UiBox, UiButton, UiImage, UiQuestionnaireLayout, UiSimpleGrid, UiText} from '~/components/elements';
import {ScrollToBottomButton} from '~/components/shared/ScrollToBottomButton';
import {SEXUAL_HEALTH_KEYS} from '~/constants/medical-questionnaires';
import {useInput, useNotification} from '~/hooks';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {Option} from '~/redux/questionnaires/types';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire6Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[SEXUAL_HEALTH_KEYS.HOW_LONG_HAD_SYMPTOMS]?.data,
  );

  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === SEXUAL_HEALTH_KEYS.HOW_LONG_HAD_SYMPTOMS);

  let medicalOptions: Option[] = [];
  if (questionnaire?.options?.length) {
    medicalOptions = questionnaire?.options?.filter(i => i?.value !== 'NONE');
  }

  const {inputs, setInputs, validation} = useInput({
    selectedOption: currentAnswer?.selectedOption || '',
  });

  const onClickOption = (answer: {value: string | number; label: string}) => {
    const {value} = answer;
    setInputs({selectedOption: value});
  };

  const onClickSubmit = async () => {
    dispatch(
      setQuestionnaireAnswer({
        key: SEXUAL_HEALTH_KEYS.HOW_LONG_HAD_SYMPTOMS,
        index: questionnaire?.index || '',
        data: inputs,
      }),
    );
    dispatch(setNextQuestionnaire({value: SEXUAL_HEALTH_KEYS.TAKEN_MEDICATION_OR_SIMILAR_CONDITION_BEFORE}));
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      disableNext={!inputs.selectedOption}
      handleOnNext={onClickSubmit}
      checkoutStep={questionnaire?.checkoutStep}
    >
      <Col alignItems="center" textAlign="center">
        <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.mLarge} mt={spacing.small} />
        <UiText fontSize="xl" fontWeight="bold" mt={spacing.medium}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiBox mt={spacing.small} w="100%">
          <UiSimpleGrid columns={1} spacing={5}>
            {questionnaire?.options?.map(value => (
              <ScrollToBottomButton
                key={`${value.label}-${value.value}`}
                title={value.label}
                variant={inputs.selectedOption === value.value ? 'solid' : 'toggle'}
                onClick={() => onClickOption(value)}
              />
            ))}
          </UiSimpleGrid>
        </UiBox>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire6Screen;
